import { render, staticRenderFns } from "./SalaryDetails.vue?vue&type=template&id=8b2b5d9e&scoped=true"
import script from "./SalaryDetails.vue?vue&type=script&lang=js"
export * from "./SalaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SalaryDetails.vue?vue&type=style&index=0&id=8b2b5d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2b5d9e",
  null
  
)

export default component.exports